import { Trans } from 'react-i18next'
import { v4 as uuid4 } from 'uuid'

import { VariableResultUniqueID, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { appIconKeys } from '@/shared/icons/constants'

export default function VariableUniqueID({
  id,
  onChange,
}: {
  id?: string
  onChange: (value: VariableResultUniqueID) => void
}) {
  return (
    <div
      id={id}
      onClick={() => {
        onChange({
          id: uuid4(),
          flag: VariableSelectFeatureFlag.UniqueID,
        })
      }}
      className='flex-c w-full sdd-item'
    >
      <div className='flex-c w-full pointer-events-none'>
        <MaterialIcon icon={appIconKeys.uniqueId} size={16} />
        <div className='pointer-events-none'>
          <Trans>Unique Identifier</Trans>
        </div>
      </div>
    </div>
  )
}
